import React, { useRef } from 'react';
import RetroWordmark from './RetroWordmark';
import html2canvas from 'html2canvas';

const RetroSquare = ({ size = 250, className = '' }) => {
  const squareRef = useRef(null);

  const exportAs = async (format) => {
    if (!squareRef.current) return;

    // Create export container with viewport units
    const exportContainer = document.createElement('div');
    exportContainer.style.cssText = `
      position: fixed;
      left: -9999px;
      top: -9999px;
      width: 2000px;
      height: 2000px;
      background-color: #F9F9F7;
      display: grid;
      place-items: center;
      overflow: hidden;
    `;

    // Create inner container for the wordmark
    const innerContainer = document.createElement('div');
    innerContainer.style.cssText = `
      display: grid;
      place-items: center;
      width: 100%;
      height: 100%;
      transform: translateY(-25%); /* Increased offset for better centering */
    `;

    // Create the wordmark wrapper
    const wordmarkWrapper = document.createElement('div');
    wordmarkWrapper.style.cssText = `
      display: grid;
      place-items: center;
      transform: scale(8);
    `;

    // Clone the actual wordmark
    const wordmark = squareRef.current.querySelector('.wordmark-content').cloneNode(true);

    // Assemble the structure
    wordmarkWrapper.appendChild(wordmark);
    innerContainer.appendChild(wordmarkWrapper);
    exportContainer.appendChild(innerContainer);
    document.body.appendChild(exportContainer);

    try {
      const canvas = await html2canvas(exportContainer, {
        backgroundColor: '#F9F9F7',
        scale: 1,
        useCORS: true,
        allowTaint: true,
        width: 2000,
        height: 2000,
        logging: true
      });

      canvas.toBlob((blob) => {
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = 'retro-square.png';
        downloadLink.click();
      });
    } finally {
      document.body.removeChild(exportContainer);
    }
  };

  return (
    <div className="flex flex-col items-center">
      <div 
        ref={squareRef}
        style={{
          width: size,
          height: size,
          backgroundColor: '#F9F9F7',
          display: 'grid',
          placeItems: 'center',
          cursor: 'pointer',
          borderRadius: '0.5rem'
        }}
        className={className}
      >
        <div className="wordmark-content">
          <RetroWordmark size="2xl" />
        </div>
      </div>
      <div className="flex gap-2 mt-4">
        <button 
          onClick={() => exportAs('png')}
          className="px-3 py-1 bg-gray-700 text-white rounded hover:bg-gray-600 font-['VT323']"
        >
          Save PNG
        </button>
      </div>
    </div>
  );
};

export default RetroSquare; 